import React, { Suspense, lazy } from "react";
import PageHero from "../components/PageHero";
import SectionNav from "../components/AboutUs/SectionNav";
import FounderSection from "../components/AboutUs/FounderSection";
import MissionVision from "../components/AboutUs/MissionVission";
import WeAre from "../components/AboutUs/WeAre";
import Expertise from "../components/AboutUs/Expertise";
import PlantAndMachinery from "../components/AboutUs/PlantAndMachinery";
import Partners from "../components/AboutUs/Partners";

// The map (Leaflet) is only needed here, so keep it out of the main bundle.
const Footprint = lazy(() => import("../components/AboutUs/Footprint"));

const sections = [
  { id: "founder-section", label: "Founder" },
  { id: "mission-vision", label: "Mission & Vision" },
  { id: "we-are", label: "We Are" },
  { id: "expertise", label: "Our Expertise" },
  { id: "plant-machinery", label: "Plant & Machinery" },
  { id: "partners", label: "Our Partners" },
  { id: "footprint", label: "Our Footprint" },
];

function AboutUsPage() {
  return (
    <>
      <PageHero title="About Us" />
      <SectionNav sections={sections} />
      <FounderSection />
      <MissionVision />
      <WeAre />
      <Expertise />
      <PlantAndMachinery />
      <Partners />
      <Suspense
        fallback={<section id="footprint" className="scroll-mt-36 py-16 sm:py-24 min-h-[720px]" aria-busy="true" />}
      >
        <Footprint />
      </Suspense>
    </>
  );
}

export default AboutUsPage;
